import React, { useEffect, useState } from 'react'
import { MobileFundCard } from '../MobileFundCard.jsx'
import {
  MUTUAL_FUND_PATH,
  ETF_PATH,
} from '../../../../components/FundDetails/Helpers/FundTypes.js'

export const MutualFundsMobile = ({
  funds,
  filteredFunds,
  isFilterOn,
  section,
  renderStars,
  displayPrimaryBenchmark,
  displayMorningstarAverage,
  displayMorningstarGroup,
  product,
  fundRoot,
  selectedPerformanceType,
}) => {
  const [sortedFunds, setSortedFunds] = useState([])
  const [msGroupedFunds, setMsGroupedFunds] = useState([])

  // For mutual funds, asOfDates are stored at the root level of the data, so we need to extract them and pass them down to each fund card
  // instead of passing the entire fundRoot which contains all 88 funds, would be costly to do
  const asOfDates = {
    ytdAsOfDate: fundRoot?.ytdAsOfDate,
    navAsOfDate: fundRoot?.navAsOfDate,
    popAsOfDate: fundRoot?.popAsOfDate,
    expenseAsOfDate: fundRoot?.expenseAsOfDate,
    priceAsOfDate: fundRoot?.priceAsOfDate,
    secYldDate: fundRoot?.secYldDate,
  }

  useEffect(() => {
    const _funds = isFilterOn ? filteredFunds : funds
    const sortKey = product === ETF_PATH ? 'symbol' : 'fundName'
    const sorted = [..._funds].sort((a, b) =>
      (a[sortKey] || '').localeCompare(b[sortKey] || '')
    )
    if (section === '#morningstar-ratings') {
      const grouped = _funds.reduce((acc, fund) => {
        const category = fund.msCategoryName
        if (!acc[category]) acc[category] = []
        acc[category].push(fund)
        return acc
      }, {})

      const sortedGrouped = Object.entries(grouped).sort(([a], [b]) =>
        a.localeCompare(b)
      )
      setMsGroupedFunds(sortedGrouped)
    }
    setSortedFunds(sorted)
  }, [isFilterOn, filteredFunds, funds])

  return product === MUTUAL_FUND_PATH ? (
    <>
      {displayMorningstarGroup ? (
        <div className="Accordion">
          {msGroupedFunds.map(([category, funds]) => (
            <details className="Accordion-item" key={category}>
              <summary className="Accordion-toggle Accordion--productGrouping u-bgColorSlateLight u-paddingVert2gu u-textNormal">
                Morningstar Category: {category}
              </summary>
              <div className="u-marginTop4gu">
                {funds.map((fund) => (
                  <MobileFundCard
                    key={fund.cusip}
                    fund={fund}
                    product={product}
                    section={section}
                    renderStars={renderStars}
                    displayPrimaryBenchmark={displayPrimaryBenchmark}
                    displayMorningstarAverage={displayMorningstarAverage}
                    asOfDates={asOfDates}
                    selectedPerformanceType={selectedPerformanceType}
                  />
                ))}
              </div>
            </details>
          ))}
        </div>
      ) : (
        sortedFunds.map((fund) => {
          return (
            <MobileFundCard
              key={fund.cusip}
              fund={fund}
              product={product}
              section={section}
              renderStars={renderStars}
              displayPrimaryBenchmark={displayPrimaryBenchmark}
              displayMorningstarAverage={displayMorningstarAverage}
              asOfDates={asOfDates}
              selectedPerformanceType={selectedPerformanceType}
            />
          )
        })
      )}
    </>
  ) : (
    <div className="Accordion">
      {displayMorningstarGroup
        ? msGroupedFunds.map(([category, funds]) => (
            <details className="Accordion-item" key={category}>
              <summary className="Accordion-toggle Accordion--productGrouping u-bgColorSlateLight u-paddingVert2gu u-textNormal">
                Morningstar Category: {category}
              </summary>
              <div className="u-marginTop4gu">
                {funds.map((fund) => (
                  <MobileFundCard
                    key={fund.cusip}
                    fund={fund}
                    product={product}
                    section={section}
                    renderStars={renderStars}
                    displayPrimaryBenchmark={displayPrimaryBenchmark}
                    displayMorningstarAverage={displayMorningstarAverage}
                    asOfDates={asOfDates}
                    selectedPerformanceType={selectedPerformanceType}
                  />
                ))}
              </div>
            </details>
          ))
        : sortedFunds.map((fund) => {
            return (
              <MobileFundCard
                key={fund.cusip}
                fund={fund}
                product={product}
                section={section}
                renderStars={renderStars}
                displayPrimaryBenchmark={displayPrimaryBenchmark}
                displayMorningstarAverage={displayMorningstarAverage}
                asOfDates={asOfDates}
                selectedPerformanceType={selectedPerformanceType}
              />
            )
          })}
    </div>
  )
}
